module.exports = __webpack_public_path__ + "img/glasses-disabled.cd811433.svg";